var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.RESOURCE_LOAD_COMPLETE) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('alert', {
    attrs: {
      "message": _vm.alertOPT.message,
      "type": _vm.alertOPT.type,
      "closeModal": _vm.alertOPT.action
    },
    on: {
      "API": function($event) {
        _vm.alertAPI = $event
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243b1d82","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 1762
// module chunks = 1